import { createSlice } from "@reduxjs/toolkit";
import { status } from "../../_constants/common";
import { fetchDashboardOrders } from "./ReportThunk";

export const initialFilters = {
    fulfillmentStatus: "all",
    dateRange: "all",
    deliveryType: "all",
    paymentStatus: "all",
    paymentMethodType: "all",
    search: "",
};

const reportSlice = createSlice({
    name: "report",
    initialState: {
        filters: { ...initialFilters },
        list: {
            status: null,
            data: [],
            error: null,
            meta: { total: 0, page: 1, limit: 10, totalPages: 1 },
        },
        summary: { totalOrders: 0, totalRevenue: 0, avgOrderAmount: 0 },
    },
    reducers: {
        setFilter: (state, { payload }) => {
            state.filters[payload.key] = payload.value;
        },
        resetFilters: (state) => {
            state.filters = { ...initialFilters };
        },
        setPage: (state, { payload }) => {
            state.list.meta.page = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboardOrders.pending, (state) => {
                state.list.status = status.IN_PROGRESS;
                state.list.error = null;
            })
            .addCase(fetchDashboardOrders.fulfilled, (state, { payload }) => {
                state.list.status = status.SUCCESS;

                state.list.data = Array.isArray(payload?.data) ? payload.data : [];
                state.list.meta = payload?.meta || state.list.meta;
                state.summary = payload?.summary || state.summary;
            })

            .addCase(fetchDashboardOrders.rejected, (state, action) => {
                state.list.status = status.FAILURE;
                state.list.error = action.payload || action.error?.message;
            });
    },
});

export const { setFilter, resetFilters, setPage } = reportSlice.actions;
export default reportSlice.reducer;
